module.exports = __webpack_public_path__ + "static/media/java.cc33ff64.png";